import React, { useEffect, useState } from 'react';
import { Search, X } from 'react-feather';
import { SearchBarProps } from './searchbar.props';
import { SearchIcon, SearchIconWhite } from '../../assets/images';
import './searchbar.css';
import StyledTooltip from '../tooltip';

export default function Searchbar({
  id,
  className,
  placeholder,
  initialValue,
  handleSearchByChange,
  handleSearchBySubmit,
  backgroundColor,
  whiteSearchIcon,
  value: propValue,
  variant = 'default',
}: SearchBarProps) {
  const [value, setValue] = useState<string>(initialValue || '');
  const debounceRef = React.useRef<number | null>(null);

  useEffect(() => {
    if (typeof propValue === 'string') {
      setValue(propValue);
    }
  }, [propValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVal = e.target.value;
    setValue(newVal);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = window.setTimeout(() => {
      handleSearchByChange?.(newVal);
    }, 300);
  };

  const handleClearSearch = () => {
    setValue('');
    window.setTimeout(() => {
      handleSearchByChange?.('');
    }, 300);
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSearchBySubmit?.(value);
  };

  if (variant === 'compact') {
    return (
      <form className={`relative w-full ${className || ''}`} onSubmit={onSubmit} id={`form-${id}`}>
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
        <input
          type="search"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          id={id}
          className="w-full pl-9 pr-8 h-10 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder:text-gray-500 outline-none focus:ring-2 focus:ring-[hsl(var(--primary))]/20 focus:border-[hsl(var(--primary))] text-sm transition-colors"
        />
        {value && (
          <button
            type="button"
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors"
            onClick={handleClearSearch}
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </form>
    );
  }

  return (
    <form
      className={`${
        className
      }w-full box-border gap-x-[1.5] py-[18px] px-[16px] h-[40px] overflow-hidden flex relative items-center rounded ${
        (backgroundColor ?? '')
          ? ''
          : 'border-1 border-1.5 border-solid border-[rgb(228, 228, 231)]'
      }`}
      style={{ width: '100%' }}
      onSubmit={onSubmit}
      id={`form-${id}`}
    >
      <img
        src={whiteSearchIcon ? SearchIconWhite : SearchIcon}
        alt="search"
        className="search-icon"
      />
      <input
        className={`border-0 outline-none h-[40px] w-full p-[0.5rem] ${
          backgroundColor ? `${backgroundColor} placeholder:text-white` : ''
        }`}
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        id={id}
      />
      {value && (
        <StyledTooltip title="Clear search">
          <button
            type="button"
            className="clear-search absolute right-[0.4rem] cursor-pointer leading-0"
            onClick={handleClearSearch}
          >
            <X className="clear-search-icon stroke-lightGrey w-[13.5] h-[13.5]" />
          </button>
        </StyledTooltip>
      )}
    </form>
  );
}

Searchbar.defaultProps = {
  placeholder: 'Type to search',
  initialValue: '',
};
